import { useState, useEffect } from "react";
import Select from "react-select";
import { DoctorService } from "../../services/api/doctor.service";
import { useAuth } from "../../context/AuthContext";

interface DoctorFiltersProps {
  onFilterChange: (filters: any) => void;
}

export function DoctorFilters({ onFilterChange }: DoctorFiltersProps) {
  const {user} = useAuth()
  const [specializations, setSpecializations] = useState<{ name: string }[]>([]);

  useEffect(() => {
    async function fetchSpecializations() {
      const response = await DoctorService.getSpecializationDropdown();
      if (response.status) {
        setSpecializations(response.data);
      } else {
        console.error("Failed to fetch specializations:", response.message);
      }
    }
    fetchSpecializations();
  }, []);

  // Transform specialization data into react-select format
  const specializationOptions = specializations.map((spec) => ({
    value: spec.name,
    label: spec.name,
  }));

  return (
    <div className={`${user?.role.toLocaleLowerCase() === "clinic"? "flex gap-4 -mt-10" : user?.role.toLocaleLowerCase() === "admin" ? "relative right-64 -top-1 mr-4 " : null }`} >
      {/* Specialization Filter using React-Select */}
      <Select
        options={specializationOptions}
        onChange={(selectedOption) =>
          onFilterChange({ specialization: selectedOption?.value || "" })
        }
        placeholder="Select Specialization"
        isClearable
        className="w-64" // Adjust width as needed
      />

      {/* Status Filter */}
      {/* <select
        onChange={(e) => onFilterChange({ status: e.target.value })}
        className="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-purple-500"
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="onLeave">On Leave</option>
      </select> */}
    </div>
  );
}
